/**
 * 학생정보 검색조건 화면
 */
import React, { Component } from 'react';
import { Navbar, Button, Form, Container, Row, Col } from 'react-bootstrap';
import { hakgwaList, banArr, sc_stdt, udfSetScInfo, udfSetSearchCondition } from '../../common/usr/stdtList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import SideMenuCmp from './SideMenuCmp';
import { udfAutoLogin } from '../../common/common';

class StdtSearchCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      SF_HAKGWA: sc_stdt.SF_HAKGWA,
      SF_GRADE: sc_stdt.SF_GRADE,
      SF_BAN: sc_stdt.SF_BAN,
      SF_STD_STATUS: sc_stdt.SF_STD_STATUS,
      SF_PRMT_YN: sc_stdt.SF_PRMT_YN,
      searchKeyword: sc_stdt.searchKeyword,
      usrInfo: null,
    };
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'USR') {
        this.setState({ usrInfo: data });
      } else {
        this.props.history.push('/');
      }
    });
  }

  handleChange = (e) => {
    udfSetSearchCondition('stdt', e.target.name, e.target.value);
  }

  render() {
    const setHakgwaList = hakgwaList.map((str, idx) => (
      <option value={str} key={idx}>{str}</option>
    ));

    const setBanArr = banArr.map((ban, idx) => (
      <option value={ban} key={idx}>{ban} 반</option>
    ));

    return (
      <>
        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          검색조건
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
          />
        </Navbar>

        <Container style={{ marginTop: '65px' }}>
          <Row>
            <Col>
              <Form.Label>학과</Form.Label>
              <Form.Control as='select' className="bg-light text-muted" name='SF_HAKGWA' defaultValue={this.state.SF_HAKGWA} onChange={this.handleChange}>
                <option value=''>전체</option>
                {setHakgwaList}
              </Form.Control>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Form.Label>학년</Form.Label>
              <Form.Control as='select' className="bg-light text-muted" name='SF_GRADE' defaultValue={this.state.SF_GRADE} onChange={this.handleChange}>
                <option value=''>전체</option>
                <option value='1'>1 학년</option>
                <option value='2'>2 학년</option>
                <option value='3'>3 학년</option>
                <option value='4'>4 학년</option>
                <option value='5'>5 학년</option>
                <option value='6'>6 학년</option>
              </Form.Control>
            </Col>
            <Col>
              <Form.Label>반</Form.Label>
              <Form.Control as='select' className="bg-light text-muted" name='SF_BAN' defaultValue={this.state.SF_BAN} onChange={this.handleChange}>
                <option value=''>전체</option>
                {setBanArr}
              </Form.Control>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Form.Label>재학구분</Form.Label>
              <Form.Control as='select' className="bg-light text-muted" name='SF_STD_STATUS' defaultValue={this.state.SF_STD_STATUS} onChange={this.handleChange}>
                <option value='1'>재학</option>
                <option value='2'>재학아님</option>
              </Form.Control>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Form.Label>학생이름</Form.Label>
              <Form.Control type='text' className="bg-light text-muted" name='searchKeyword' defaultValue={this.state.searchKeyword} onChange={this.handleChange} />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Link to='/usr/stdtList' onClick={() => udfSetScInfo('stdt', true, false)}>
                <Button className='mt-2 btn btn-height btn-school-life col'>검색</Button>
              </Link>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default StdtSearchCmp;